import { COMMON_ERRORS } from 'modules/common/constants/errors.references';

export const ERROR_REFS = {
  ...COMMON_ERRORS,
  // add new error refs here
};

export const ACCOUNT_DELETION_REASON_ERRORS = {
  [ERROR_REFS.DUPLICATE_KEY]: {
    title: 'accountDeletionReason:errors.duplicatedName',
    description: 'accountDeletionReason:errors.duplicatedNameDescription',
  }
};
